import { Resource as i, API as a } from "@coveo/platform-client";
const t = class t extends i {
  /**
   * Returns a paginated list of case assist configurations for the specified project.
   *
   * @param {string} projectId ID of the project for which to retrieve case assist configurations.
   * @param {CaseAssistConfigListOptions} options Options to filter and paginate the results.
   * @returns {Promise<PageModel<CaseAssistConfigModel>>} Paginated list of case assist configurations for the specified project.
   */
  listCaseAssistConfigsByProjectId(r, e = {}) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/projects/get`, {
        ...e,
        projectId: r
      })
    );
  }
};
t.baseUrl = `/rest/organizations/${a.orgPlaceholder}/caseassists`;
let s = t;
export {
  s as CaseAssistConfigsInternalResource
};
//# sourceMappingURL=CaseAssistConfigstInternalResource.js.map
